import React from 'react';
import { Helmet } from 'react-helmet-async';

import { FeatureFlag } from 'src/shared/constants';
import { isDevelopment, isProduction } from 'src/shared/helpers/environment';
import { useTreatment } from 'src/shared/hooks/useSplit';

const OneTrust = () => {
  const shouldIncludeScript =
    useTreatment(FeatureFlag.Web.COOKIE_MANAGEMENT) === 'on' &&
    isDevelopment() === false;

  if (!shouldIncludeScript) return null;

  const dataDomainScript = isProduction()
    ? '04e234ab-c075-42db-bb41-e9f637472c68'
    : '04e234ab-c075-42db-bb41-e9f637472c68-test';
  const autoBlockSrc = `https://cdn.cookielaw.org/consent/${dataDomainScript}/OtAutoBlock.js`;

  return (
    <Helmet>
      <script charSet="UTF-8" src={autoBlockSrc} type="text/javascript" />
      <script
        charSet="UTF-8"
        data-domain-script={dataDomainScript}
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
      />
    </Helmet>
  );
};

export { OneTrust };
